module.exports = __webpack_public_path__ + "static/media/bonis.6e6d2a26.webp";